import { AbstractControl, ValidationErrors } from '@angular/forms';
import { validationPatterns } from '@up/data';

export const emailRule = validationPatterns.email;
/**
 * Checks whether the `value` is a valid email address.
 * @param value String that we want to check if it is a valid email address.
 * @returns `true` if it is a valid email address.
 */
export function validateEmail(value: string): boolean {
  return emailRule.test(value);
}

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if(!value) return null;
  const isValid = validateEmail(value);
  return isValid ? null : { email: true };
}